/* eslint-disable no-ex-assign */
import { createModel } from "@rematch/core";
import { ethers } from "ethers";
import { BigNumber } from "bignumber.js";
import { Pets__factory } from "../contract/types/ethers-contracts/factories/Pets__factory";
import { Pets } from "../contract/types/ethers-contracts/Pets";
import { RootModel } from ".";
import { MAIN_CONTRACT, RINKEBY_CONTRACT } from "../config/contract";
const CONFIG = MAIN_CONTRACT;

const PETS_CONTRACT_ADDRESS = CONFIG.pets;

// const PETS_CONTRACT_ADDRESS_TEST = "0xC14c96CeBfF2C3C75540BbD19869Fd76fe49DC03";

const UNIT_PRICE = 0.01;

declare global {
  interface Window {
    ethereum: ethers.providers.ExternalProvider;
  }
}

interface PetsState {
  PetsContract?: Pets;
  roleDailyMint: number;
}

const initMainState: PetsState = {
  roleDailyMint: 0,
};

export const pets = createModel<RootModel>()({
  state: initMainState,
  reducers: {
    setFields(state, fields: Partial<PetsState>): PetsState {
      return {
        ...state,
        ...fields,
      };
    },
  },
  effects: (dispatch) => ({
    async initPetsContract(_payload: any, state) {
      let { ethersProvider, signer } = state.main;
      if (ethersProvider && signer) {
        // 连接合约
        let PetsContract = Pets__factory.connect(PETS_CONTRACT_ADDRESS, signer);
        // const isMainNet = netWorkInfo.chainId === CONFIG.NET_ID;
        dispatch.pets.setFields({
          PetsContract,
        });

        try {
          let roleDailyMint = await PetsContract.roleDailyMintNum();
          dispatch.pets.setFields({
            roleDailyMint: roleDailyMint.toNumber(),
          });
        } catch (error) {
          console.error(error);
        }
      }
    },
    async lootClaim(
      payload: {
        tokenId: number;
        lootId: number;
      },
      state
    ) {
      let { PetsContract } = state.pets;
      if (PetsContract && payload !== undefined) {
        let mintHash;
        try {
          mintHash = await PetsContract.lootClaim(
            payload?.tokenId,
            payload?.lootId
          );
          let result = await mintHash.wait();
          if (result.status === 1) {
            dispatch.main.openAlert({
              type: "success",
              content: "Congratulations! Transaction Confrimed!",
            });
            dispatch.main.setFields({
              party: true,
            });
          }
        } catch (MetaMaskError: any) {
          const { error } = JSON.parse(JSON.stringify(MetaMaskError));
          if (MetaMaskError?.code === 4001) {
            // 用户取消交易
            dispatch.main.openAlert({
              type: "error",
              content: MetaMaskError.message,
            });
          } else {
            dispatch.main.openAlert({
              type: "error",
              content: error?.message,
            });
          }
        }
      }
    },
    async mlootClaim(
      payload: {
        tokenId: number;
        lootId: number;
      },
      state
    ) {
      let { PetsContract } = state.pets;
      if (PetsContract && payload !== undefined) {
        let mintHash;
        try {
          mintHash = await PetsContract.mlootClaim(
            payload?.tokenId,
            payload?.lootId
          );
          let result = await mintHash.wait();
          if (result.status === 1) {
            dispatch.main.openAlert({
              type: "success",
              content: "Congratulations! Transaction Confrimed!",
            });
            dispatch.main.setFields({
              party: true,
            });
          }
        } catch (MetaMaskError: any) {
          const { error } = JSON.parse(JSON.stringify(MetaMaskError));
          if (MetaMaskError?.code === 4001) {
            // 用户取消交易
            dispatch.main.openAlert({
              type: "error",
              content: MetaMaskError.message,
            });
          } else {
            dispatch.main.openAlert({
              type: "error",
              content: error?.message,
            });
          }
        }
      }
    },
    async roleClaim(payload, state) {
      let { PetsContract } = state.pets;
      if (PetsContract) {
        let mintHash;
        try {
          mintHash = await PetsContract.roleClaim();
          let result = await mintHash.wait();
          if (result.status === 1) {
            dispatch.main.openAlert({
              type: "success",
              content: "Congratulations! Transaction Confrimed!",
            });
            dispatch.main.setFields({
              party: true,
            });
          }
        } catch (MetaMaskError: any) {
          const { error } = JSON.parse(JSON.stringify(MetaMaskError));
          if (MetaMaskError?.code === 4001) {
            // 用户取消交易
            dispatch.main.openAlert({
              type: "error",
              content: MetaMaskError.message,
            });
          } else {
            dispatch.main.openAlert({
              type: "error",
              content: error?.message,
            });
          }
        }
      }
    },
    async mintPets(payload: number, state) {
      console.log("🚀 ~ file: pets.ts ~ line 83 ~ mintPets ~ payload", payload);
      let { PetsContract } = state.pets;
      if (PetsContract && payload !== undefined) {
        let mintHash;
        try {
          mintHash = await PetsContract.mint(payload, {
            value: ethers.utils.parseEther(
              new BigNumber(1).times(UNIT_PRICE).toString()
            ),
          });
          let result = await mintHash.wait();
          if (result.status === 1) {
            dispatch.main.openAlert({
              type: "success",
              content: "Congratulations! Transaction Confrimed!",
            });
            dispatch.main.setFields({
              party: true,
            });
          }
        } catch (MetaMaskError: any) {
          const { error } = JSON.parse(JSON.stringify(MetaMaskError));
          if (MetaMaskError?.code === 4001) {
            // 用户取消交易
            dispatch.main.openAlert({
              type: "error",
              content: MetaMaskError.message,
            });
          } else {
            dispatch.main.openAlert({
              type: "error",
              content: error?.message,
            });
          }
        }
      }
    },
  }),
});
